import axios from 'axios';

import Cookies from 'js-cookie';
import Api from './ApiUrl'
const API_URL = `${Api}/api/v1/subcategory`;

// export const getSubcategories = async () => {
//     const config = {
//         // headers: {Authorization: `Bearer ${Cookies.get('token')}`},
//         role: 'admin'
//       };
//   const response = await axios.get(API_URL);
//   return response.data;
// };

export const getSubcategories = async () => {
  const config = {
      // headers: {
      //     Authorization: `Bearer ${Cookies.get('token')}`,
      // },
      role: 'admin'
  };

  try {
      const response = await axios.get(API_URL, config);
      return response.data;
  } catch (error) {
      console.error("Error fetching subcategories:", error);
      throw error;  // Re-throw the error to handle it where the function is called
  }
};











export const getSubcategoryById = async (id) => {
  const config = {
    // headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },
    role: 'admin'
};
const response = await axios.get(`${API_URL}/${id}`,config);
return response.data;
};


export const createSubcategory = async (subcategory) => {
  const config = {
    // headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },
    role: 'admin'
};
  const response = await axios.post(API_URL, subcategory,config);
  return response.data;
};

export const updateSubcategory = async (id, subcategory) => {
  const config = {
    // headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },
    role: 'admin'
};
  const response = await axios.put(`${API_URL}/${id}`, subcategory,config);
  return response.data;
};

export const deleteSubcategory = async (id) => {
  const config = {
    // headers: {
    //     Authorization: `Bearer ${Cookies.get('token')}`,
    // },
    role: 'admin'
};
  const response = await axios.delete(`${API_URL}/${id}`,config);
  return response.data;
};
